import { connect } from 'react-redux';
import { HeatMapCell } from '../../../components/chart/HeatMapChart';
import * as fromState from '../../../state/reducers';

const mapStateToProps = (state, { chartType, id }) => ({
  highlighted: id === fromState.getHoverLine(state, chartType)
});

export default connect(mapStateToProps)(HeatMapCell);